<template>
  <div class="may24th-campaign">
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          АЗ ЗНАЯ
        </div>
      </div>
      <div class="info-box-content">
        буквите и животът със знанието е добър
      </div>
    </div>
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          ВЪРВИ
        </div>
      </div>
      <div class="info-box-content">
        народе възродени,<br>
        към светла бъднина върви...
      </div>
    </div>
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          НАПРЕД!
        </div>
      </div>
      <div class="info-box-content">
        Народността не пада там,<br>
        дето знаньето живей!
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "may24th-slogan-component"
}
</script>

<style scoped>
.may24th-campaign .info-box {
  width: 320px;
}

.may24th-campaign .info-box .info-box-content {
  padding: 5px 15px;
}

.info-box-title {
  flex-basis: 120px;
  height: 80px;
  font-size: 1rem;
}

@media (min-width: 576px) {
  .may24th-campaign .info-box {
    width: 400px;
  }

  .may24th-campaign .info-box .info-box-content {
    padding: 15px;
  }
}
</style>
